import React, { useEffect, useRef, useState } from "react";
import { connect, useSelector } from "react-redux";
import { loadPageData } from "../../actions";

import { SCPaymentSection, SCPaymentContent } from "../Payment/css";
import {
  IconDone,
  IconAttention,
  Alert
} from "@payright/web-components";
import MakeLoanPayment from "./MakeLoanPayment";
import Loader from "../Common/Loader";
import {
  handlePaymentSubmit,
  handleAddCardSubmit,
  handleChangeCardSubmit,
  handleChangePaymentMethod,
  handleAddNewCard
} from "../../actions/paymentActions";
import * as CONSTANT from "../../util/constants/messages";
import Footer from "../Footer";
import { Nav } from "../Nav";
import { RootState } from "../../reducers";
import { fetchLoans, setSelectedLoan } from "../../actions/loanActions";
import { makeLoanPaymentLoad } from "../../actions/loanPaymentActions";
import ChangePayment from "./ChangeLoanPayment";
import AddPaymentMethod from "../Payment/AddPaymentMethod";

interface PaymentProps {
  customerId?: any;
  loadPageData(): void;
  overDuePayments?: any;
  paymentMethods?: any;
  defaultPaymentMethod?: any;
  token?: any;
  selectedCardNumber?: any;
  visibleMakePayment?: boolean;
  visibleChangePayment?: boolean;
  visibleAddNewCard?: boolean;
  handleChangeLoanPaymentMethodClick?: Function;
  handleAddNewCardClick?: Function;
  dispatch?: Function;
  router?: any;
  totalBalanceOwing?: string;
}

interface LoanProps {
  ID: any;
  balanceRemaining: any;
  loanName: {name: string, ref: string};
  nextRepaymentDate: any;
  paidLoanAmount: any;
  status: any;
  interest: any;
  principal: any;
  payoutAmount: any;
}

let LoanPaymentContainer = (props :PaymentProps) => {
  const {
    customerId,
    loadPageData,
    dispatch,
    router,
    handleChangeLoanPaymentMethodClick,
    defaultPaymentMethod,
    visibleMakePayment,
    visibleChangePayment,
    paymentMethods,
    handleAddNewCardClick,
    selectedCardNumber,
    visibleAddNewCard,
  } = props;

  const { loans } = useSelector<RootState, {loans: LoanProps[]}>(state => ({
    loans: state.loans.items
  }));

  const [loanListOptions, setLoanListOptions] = useState([]);

  const getLoanList = (loanList) => {
    const filteredActive = loanList.filter(loan => loan.status === 'active');
    if (filteredActive.length > 0){
      return filteredActive.map(obj => ({
        name: obj.loanName.name, 
        value: obj.ID
      }));
    }else{
      return [];
    } 
  }

  useEffect(() => {
    if (customerId === null) {
      loadPageData();
    }
  },[customerId])

  const mounted = useRef(false);
  useEffect(() => {
    if (!mounted.current) {
      const mode = router.location.hash;
      if(mode === '#change-card') {
        dispatch(handleChangePaymentMethod());
      }
      mounted.current = true;
    } else {
      dispatch(makeLoanPaymentLoad());
    }
  }, [router.location]);

  useEffect(() => {
    if (!loans)  {
      dispatch(fetchLoans());
    }
    if (loans) {
      setLoanListOptions(getLoanList(loans));
    }
  }, [loans])

  const showMessages = (submitSucceeded, error, message) => {
    if (submitSucceeded) {
      return (
        <Alert
          title={CONSTANT.SUCCESS_ALERT_TITLE}
          body={message}
          outcome="positive"
          icon={<IconDone />}
        />
      );
    } else if (error) {
      return (
        <Alert
          title={CONSTANT.PAYMENT_FAILURE_TITLE}
          body={CONSTANT.PAYMENT_FAILURE_MSG}
          outcome="error"
          icon={<IconAttention />}
        />
      );
    }
  };

  const handleLoanSelect = (id) => {
    const loanSelected = loans.find(loan => loan.ID === id);
    dispatch(setSelectedLoan(loanSelected));
  }

  const showPaymentContent = () => {
    if (visibleMakePayment) {
      return (
        <MakeLoanPayment
          defaultPaymentMethod={defaultPaymentMethod}
          handleChangePaymentMethod={handleChangeLoanPaymentMethodClick}
          onSubmit={handlePaymentSubmit}
          showMessages={showMessages}
          loanListOptions={loanListOptions}
          handleLoanSelect={handleLoanSelect}
        />
      );
    }

    if (visibleChangePayment) {
      return (
        <ChangePayment
          paymentMethods={paymentMethods}
          handleAddNewCard={handleAddNewCardClick}
          selectedCardNumber={selectedCardNumber}
          onSubmit={handleChangeCardSubmit}
          showMessages={showMessages}
        />
      );
    }

    if (visibleAddNewCard) {
      return (
        <AddPaymentMethod
          showMessages={showMessages}
          onSubmit={handleAddCardSubmit}
        />
      );
    }
  };

  if (customerId !== null) {
    return (
      <SCPaymentSection>
        <Nav activePage="/payments" />
        <SCPaymentContent>
          {showPaymentContent()}
        </SCPaymentContent>
        <Footer />
      </SCPaymentSection>
    );
  } else {
    return (
      <SCPaymentSection>
        <Loader text={CONSTANT.LOADING_TEXT} />
      </SCPaymentSection>
    );
  }
  
}

const mapStateToProps = state => {
  return {
    customerId: state.auth.customerId,
    token: state.auth.authToken,
    isSignedIn: state.auth.isSignedIn,
    paymentMethods: state.pageData.paymentMethods,
    defaultPaymentMethod: state.pageData.defaultPaymentMethod,
    selectedCardNumber:
      state.pageData.defaultPaymentMethod !== null
        ? state.pageData.defaultPaymentMethod.id
        : null,
    visibleMakePayment: state.loanPayments.visibleMakePayment,
    visibleChangePayment: state.loanPayments.visibleChangePayment,
    visibleAddNewCard: state.loanPayments.visibleAddNewCard,
    router: state.router,
    totalBalanceOwing:
      state.pageData.customer !== null
        ? state.pageData.customer.totalBalanceOwing
        : null,
  };
};

const mapDispatchToProps = dispatch => ({
  loadPageData: () => dispatch(loadPageData()),
  handleChangeLoanPaymentMethodClick: () => dispatch(handleChangePaymentMethod()),
  handleAddNewCardClick: () => dispatch(handleAddNewCard()),
  dispatch
});

export default connect(mapStateToProps, mapDispatchToProps)(LoanPaymentContainer);

